import React from 'react';
import { useHeaderContext } from '../Hooks/headerStates';
import * as S from './styled';
import HeaderMobile from '../HeaderMobile';
import HeaderDesktop from '../HeaderDesktop';

const HeaderWrapper = ({ isMobile, brand }) => {
  const { getMenuMobileOpenState } = useHeaderContext();
  const menuOpenState = getMenuMobileOpenState();

  return (
    <S.Header
      id='Header-header'
      className='Header-header'
      data-testid='header-header'
      menuOpenState={menuOpenState}
    >
      {isMobile ? <HeaderMobile brand={brand} /> : <HeaderDesktop brand={brand} />}
    </S.Header>
  );
};

export default HeaderWrapper;
